export default 'https://demoserver.obea-ecoute-engagement.fr/1.0/'
